import * as React from 'react';
export const IcBatteryEmptyLoading = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16 4a2 2 0 00-2-2h-4a2 2 0 00-2 2 3 3 0 00-3 3v12a3 3 0 003 3h8a3 3 0 003-3V7a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H8a1 1 0 01-1-1V7a1 1 0 011-1h1a1 1 0 001-1V4h4v1a1 1 0 001 1h1a1 1 0 011 1v12zm-3-7h-2l1.8-2.4a1 1 0 00-1.6-1.2l-3 4a1 1 0 00-.09 1 1 1 0 00.89.6h2l-1.8 2.4a1 1 0 001.6 1.2l3-4A1 1 0 0014 12z'
      fill='currentColor'
    />
  </svg>
);
